module.exports = __webpack_public_path__ + "img/399.6c157f14.jpg";